/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBarToDown = createReactComponent("arrow-bar-to-down", "IconArrowBarToDown", [
  ["path", { d: "M4 20l16 0", key: "svg-0" }],
  ["path", { d: "M12 14l0 -10", key: "svg-1" }],
  ["path", { d: "M12 14l4 -4", key: "svg-2" }],
  ["path", { d: "M12 14l-4 -4", key: "svg-3" }]
]);

export { IconArrowBarToDown as default };
//# sourceMappingURL=IconArrowBarToDown.js.map
